import { ThemeEvents, VariantUpdateEvent } from "@theme/events";
import { morph } from "@theme/morph";

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    this.inventoryLevels = {};
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
    this.prepareStockContent();
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }
  prepareStockContent = () => {
     var productInventoryContainer = this.querySelector(".product-inventory__status");
     var productID = productInventoryContainer.getAttribute("data-product-id");
     var variantID = productInventoryContainer.getAttribute("data-variant-id");

      const selectedStore =
        document.cookie
          .split("; ")
          .find((row) => row.startsWith("userSelectedLocation="))
          ?.split("=")[1] || "";

     if(selectedStore != ""){
      if(Object.keys(this.inventoryLevels).length> 0){
          this.renderStockContent(this.inventoryLevels[variantID].locations);
      }else{
        var url = "https://multiloca.info/api/get-loc-inventory-stock?shopdomain=elite-fireworks-national.myshopify.com&product_id=" + productID;
        var options = {
          method: 'GET'
        }

        fetch(url, options)
        .then((response) => {
            if (!response.ok && response.status === 429) {
              setTimeout(() => {
                  this.prepareStockContent();
              },3000);
            }else{
            return response.json();
            }
        })
          .then(json => {    
            this.inventoryLevels = json.inventoryLevels;
            var variantInventoryLevel = json.inventoryLevels[variantID];
            var inventoryLevelLocations = variantInventoryLevel.locations;
            this.renderStockContent(inventoryLevelLocations);
          });
      }
    }  

  }
  renderStockContent = (inventoryLevelLocations) => {
     var _this = this;
     var productInventoryContainer = this.querySelector(".product-inventory__status");
     var sectionID = productInventoryContainer.getAttribute("data-section-id");
     var productID = productInventoryContainer.getAttribute("data-product-id");
     var variantID = productInventoryContainer.getAttribute("data-variant-id");
     var variantAvailable = productInventoryContainer.getAttribute("data-available");
     var showInventoryQuantity = productInventoryContainer.getAttribute("data-show-quantity");
     var inventoryManagment = productInventoryContainer.getAttribute("data-inventory-managed");
     var inventoryPolicy = productInventoryContainer.getAttribute("data-inventory-policy");
     var inventoryThreshold = productInventoryContainer.getAttribute("data-threshold") * 1;
     var inventoryLowStockMsg = productInventoryContainer.getAttribute("data-inventory-low-stock");
     var inventoryInStockMsg = productInventoryContainer.getAttribute("data-inventory-in-stock");
     var inventoryOutOfStockMsg = productInventoryContainer.getAttribute(" data-inventory-out-of-stock");
     var inventoryLowStockCountMsg = productInventoryContainer.getAttribute("data-inventory-low-stock-count");
     var inventoryStatusAriaLabel = productInventoryContainer.getAttribute("data-status-aria-label");

    

     const selectedStore =
        document.cookie
          .split("; ")
          .find((row) => row.startsWith("userSelectedLocation="))
          ?.split("=")[1] || "";

     if(selectedStore != ""){

      if(inventoryLevelLocations[0].location_name.indexOf("Texas") != -1){
        var texasAvailability = inventoryLevelLocations[0].inventory_data[0].available;
        var newHampshireAvailability = inventoryLevelLocations[1].inventory_data[0].available;
      }else{
        var texasAvailability = inventoryLevelLocations[1].inventory_data[0].available;
        var newHampshireAvailability = inventoryLevelLocations[0].inventory_data[0].available;
      }

      var itemInStock = false;
      var inventoryQuantity = 0;

      if(selectedStore === "Texas" && texasAvailability > 0){
        itemInStock = true;
        inventoryQuantity = texasAvailability;
      }else if(selectedStore === "New Hampshire" && newHampshireAvailability > 0){
        itemInStock = true;
        inventoryQuantity = newHampshireAvailability;
      }


      var status, notification_type, translation_key;
  if(inventoryManagment == "true"){
    if(inventoryQuantity > 0){
      if(inventoryQuantity <= inventoryThreshold){
          status = 'low';
          notification_type = 'error';
          if(showInventoryQuantity == "true"){
            translation_key = inventoryLowStockCountMsg.replace("inventory_quantity_count",inventoryQuantity) 
          }else{
            translation_key = inventoryLowStockMsg;
          }
      }else{
          status = 'in_stock';
          notification_type = 'success';
          translation_key = inventoryInStockMsg;
      }
    }else{
      if(inventoryPolicy == 'continue'){
           status = 'in_stock';
           notification_type = 'success';
           translation_key = inventoryInStockMsg;
      }else{
        status = 'out_of_stock';
        notification_type = 'error';
        translation_key = inventoryOutOfStockMsg;
      }
    }
  }else{
    if(variantAvailable == "true"){
      status = "in_stock";
      notification_type = 'success';
      translation_key = inventoryInStockMsg;
    }else{
        status = 'out_of_stock';
        notification_type = 'error';
        translation_key = inventoryOutOfStockMsg;
    }
  }

  productInventoryContainer.classList.add("notification--"+notification_type);


    var inventoryIcon = document.createElement("span");
    inventoryIcon.classList.add("inline-flex", "icon", "product-inventory__icon", "product-inventory__icon-"+status);
      if(status == "low"){
        inventoryIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z" stroke="currentColor" stroke-width="var(--icon-stroke-width, 2)" stroke-miterlimit="10"></path><path d="M8 8.5V5" stroke="currentColor" stroke-width="var(--icon-stroke-width, 2)" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8 11.5A.75.75 0 1 0 8 10a.75.75 0 0 0 0 1.5" fill="currentColor"></path></svg>';
      }else if(status == "in_stock"){
         inventoryIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><path fill="none" d="M0 0h256v256H0z"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width, 2)" d="m40 144 56 56L224 72"></path></svg>';
      }else{
        inventoryIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path width="256" height="256" fill="none" d="M0 0H20V20H0V0z"></path><path x1="200" y1="56" x2="56" y2="200" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width, 2)" d="M15.625 4.375L4.375 15.625"></path><path x1="200" y1="200" x2="56" y2="56" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width, 2)" d="M15.625 15.625L4.375 4.375"></path></svg>';
      }

      productInventoryContainer.appendChild(inventoryIcon);

       var inventoryText = document.createElement("span");
      inventoryText.classList.add("product-inventory__text");
      inventoryText.id = "Inventory-"+sectionID;
      inventoryText.setAttribute("role","status");
      inventoryText.setAttribute("aria-label",inventoryStatusAriaLabel);
      inventoryText.innerHTML = translation_key;

      productInventoryContainer.appendChild(inventoryText);

     }     
  }
  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    // Skip if no HTML (cache hit - will sync via background fetch)
    if (!event.detail.data.html) return;

    // Find the correct product-inventory in HTML by matching productId
    // This prevents taking inventory from wrong product (e.g. recommendations)
    const productId = this.dataset.productId;
    let newInventory = null;

    if (productId) {
      // Find all product-inventory elements and match by productId
      const allInventories = event.detail.data.html.querySelectorAll("product-inventory");
      for (const inventory of allInventories) {
        if (inventory.dataset.productId === productId) {
          newInventory = inventory;
          break;
        }
      }
    }

    // Fallback: if no productId match, use first inventory (for single product pages)
    if (!newInventory) {
      newInventory = event.detail.data.html.querySelector("product-inventory");
    }

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });

    this.prepareStockContent();
  };
}

if (!customElements.get("product-inventory")) {
  customElements.define("product-inventory", ProductInventory);
}
